// UploadStoryFileInput.js
import { connect } from 'react-redux';

import UploadStoryFileInput from '../component/UploadStoryFileInput.jsx';

import getOperationData from '../selector/getOperationData.js';

import setPostDraftData from '../action/setPostDraftData.js';
import openPostDraft from '../action/openPostDraft.js';

import { PostDraftField } from '../resource/uploadConstants.js';

const mapStateToProps = state => {
  return {
    uploadJobType: getOperationData(
      state,
      ['postDraft', PostDraftField.ENTRY],
      'value'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setPostDraftData: ({ key, payload }) =>
      dispatch(setPostDraftData({ key, payload })),
    openPostDraft: ({ purpose, files, uploadJobType }) =>
      dispatch(
        openPostDraft({
          purpose,
          files,
          uploadJobType,
        })
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadStoryFileInput);
